import { unref as _unref, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-49054771"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "footerMenu-index"
};
const _hoisted_2 = {
  class: "main"
};
const _hoisted_3 = ["onClick"];
const _hoisted_4 = ["onClick"];
const _hoisted_5 = ["onClick"];
const _hoisted_6 = ["onClick"];
import { useRoute } from "vue-router";
export default {
  __name: 'index',
  setup(__props) {
    const route = useRoute();
    const id = route.params.id;
    return (_ctx, _cache) => {
      const _component_router_link = _resolveComponent("router-link");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createVNode(_component_router_link, {
        to: {
          name: 'boardDetail',
          params: {
            id: _unref(id)
          }
        },
        custom: ""
      }, {
        default: _withCtx(({
          navigate,
          isActive
        }) => [_createElementVNode("div", {
          class: _normalizeClass(['logo', {
            active: isActive
          }]),
          onClick: navigate
        }, "INFO", 10, _hoisted_3)]),
        _: 1
      }, 8, ["to"]), _createVNode(_component_router_link, {
        to: {
          name: 'charts',
          params: {
            id: _unref(id)
          }
        },
        custom: ""
      }, {
        default: _withCtx(({
          navigate,
          isActive
        }) => [_createElementVNode("div", {
          class: _normalizeClass(['logo', {
            active: isActive
          }]),
          onClick: navigate
        }, "CHART", 10, _hoisted_4)]),
        _: 1
      }, 8, ["to"]), _createVNode(_component_router_link, {
        to: {
          name: 'trade',
          params: {
            id: _unref(id)
          }
        },
        custom: ""
      }, {
        default: _withCtx(({
          navigate,
          isActive
        }) => [_createElementVNode("div", {
          class: _normalizeClass(['logo', {
            active: isActive
          }]),
          onClick: navigate
        }, "TRADE", 10, _hoisted_5)]),
        _: 1
      }, 8, ["to"]), _createVNode(_component_router_link, {
        to: {
          name: 'txs',
          params: {
            id: _unref(id)
          }
        },
        custom: ""
      }, {
        default: _withCtx(({
          navigate,
          isActive
        }) => [_createElementVNode("div", {
          class: _normalizeClass(['logo', {
            active: isActive
          }]),
          onClick: navigate
        }, "TXS", 10, _hoisted_6)]),
        _: 1
      }, 8, ["to"])])]);
    };
  }
};